import { render } from "./RestockComp.vue?vue&type=template&id=2634bea0&scoped=true"
import script from "./RestockComp.vue?vue&type=script&lang=js"
export * from "./RestockComp.vue?vue&type=script&lang=js"

import "./RestockComp.vue?vue&type=style&index=0&id=2634bea0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2634bea0"]])

export default __exports__